import { createFileRoute } from '@tanstack/react-router';
import { WorkOrderJobsScreen } from '@/components/work-orders';

/**
 * The Work Orders landing: the campaign's text sends as one shared team queue, grouped by
 * status. Access is enforced by the parent {@link /app/work-orders} layout guard.
 */
export const Route = createFileRoute('/app/work-orders/')({
  component: WorkOrderJobsScreen,
});
